import { useEffect, createElement } from 'react';
import config from '~src/components/helpers/config';

interface StripePricingTableProps {
  id: string;
  email: string;
}
const StripePricingTable = ({ id, email }: StripePricingTableProps) => {
  // useEffect to load the stripe pricing table script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // function to render the pricing table using createElement and the stripe-pricing-table element
  const renderStripePricingTable = () => createElement('stripe-pricing-table', {
    'pricing-table-id': id,
    'publishable-key': config.stripeAPIKey,
    'customer-email': email,
  });

  return (
    <div>
      {renderStripePricingTable()}
    </div>
  );
};

export default StripePricingTable;
